export default {
  title: 'Как работает Estimator24',
  steps: [
    {
      title: 'Анализ рынка',
      description: 'Модель анализирует цены и тренды по городу'
    },
    {
      title: 'Оценка',
      description: 'Вы получаете автоматическую оценку стоимости'
    },
    {
      title: 'Аналитика',
      description: 'Дополнительно вы видите аналоги, графики и рекомендации'
    },
    {
      title: 'Решение',
      description: 'На основе данных вы принимаете инвестиционное или личное решение'
    }
  ]
}
